import React, { useEffect } from "react";
import Background_Member2 from "../../assets/images/inner-banner.jpg";
import { Link } from "react-router-dom";

// Importing all curriculum PDFs
import DMLTCurriculum from "../../assets/pdf/curriculam/DMLTCurriculum.pdf";
import DOACurriculum from "../../assets/pdf/curriculam/Diploma in Ophthalmic Assistant.pdf";
import DMIRT from "../../assets/pdf/curriculam/Curriculum_Diploma in MRIT.pdf";
import NuclearMedicineTechnology from "../../assets/pdf/curriculam/CurriculumNuclearMedicineTechnology.pdf";
import MedicalPhysics from "../../assets/pdf/curriculam/Medical-Physics.pdf";
import MedicalPsychiatricSocialWork from "../../assets/pdf/curriculam/Final-Medical-and-Psychiatric-Social-Work.pdf";
import RespiratoryTechnology from "../../assets/pdf/curriculam/Respiratory-Technology.pdf";
import TaurmaBurn from "../../assets/pdf/curriculam/Curriculum-Taurma-Burn.pdf";
import OccupationalTherapy from "../../assets/pdf/curriculam/Occupational-Therapy.pdf";
import MedicalLaboratorySciences from "../../assets/pdf/curriculam/Medical-Laboratory-Sciences.pdf";
import Physiotherapy from "../../assets/pdf/curriculam/Physiotherapy.pdf";
import AppliedPsychologyAndBehaviouralHealth from "../../assets/pdf/curriculam/Applied-Psychology-Behavioural-Health.pdf";
import Optometry from "../../assets/pdf/curriculam/Optometry.pdf";
import NutritionAndDietetics from "../../assets/pdf/curriculam/Nutrition-and-Dietetics.pdf";
import DialysisTechnologyAndTherapy from "../../assets/pdf/curriculam/Dialysis-Technology-and-Therapy.pdf";
import RadiotherapyTechnology from "../../assets/pdf/curriculam/RADIOTHERAPY-TECHNOLOGY.pdf";
import MedicalRadiologyAndImagingTechnology from "../../assets/pdf/curriculam/MEDICAL-RADIOLOGY-AND-IMAGING-TECHNOLOGY.pdf";
import AnesthesiaAndOperationTheatreTechnology from "../../assets/pdf/curriculam/Anesthesia-and-Operation-Theatre-Technology.pdf";
import HealthInformationManagement from "../../assets/pdf/curriculam/Health-Information-Management.pdf";
import PhysicianAssociates from "../../assets/pdf/curriculam/Physician-Associates.pdf";

// corrigendum pdfs
import Corrigendum_1 from "../../assets/pdf/curriculam/corrigendum/RespiratoryTechnologyCorrigendum-1dt10Mar2026.pdf";
import Corrigendum_1MLS20March2026 from "../../assets/pdf/curriculam/corrigendum/Corrigendum-1MLS20March2026.pdf";
import Corrigendum_1Physiotherapy from "../../assets/pdf/curriculam/corrigendum/Physiotherapy-Corrigendum-1.pdf";
import Corrigendum_2Physiotherapy from "../../assets/pdf/curriculam/corrigendum/Corrigendum-2PHYSIOTHERAPY.pdf";
import Corrigendum_3Physiotherapy from "../../assets/pdf/curriculam/corrigendum/Corrigendum-3Physiotherapy.pdf";
import Corrigendum_1AppliedPsychology01Apr2026 from "../../assets/pdf/curriculam/corrigendum/Corrigendum-1AppliedPsychology01Apr2026.pdf";
import Corrigendum_Optometry from "../../assets/pdf/curriculam/corrigendum/Optometry-Corrigendum.pdf";
import Corrigendum_2Optometry from "../../assets/pdf/curriculam/corrigendum/CORRIGENDUM 2 Optometry.pdf";
import Corrigendum_HIM_1dt05Feb2026 from "../../assets/pdf/curriculam/corrigendum/HIM-Corrigendum-1-dt05Feb2026.pdf";
import Corrigendum_27_04_2026 from "../../assets/pdf/curriculam/corrigendum/Corrigendum_27_04_2026.pdf";
import Corrigendum_06_05_2026 from "../../assets/pdf/curriculam/corrigendum/CORRIGENDUM -1_MRIT_06May2026.pdf";
import Corrigendum_13_05_2026 from "../../assets/pdf/curriculam/corrigendum/CORRIGENDUM-1 Dialysis Therapy.pdf";
import Corrigendum_27_05_2026 from "../../assets/pdf/curriculam/corrigendum/RT1__27May2026.pdf";
import Corrigendum_10_04_2026 from "../../assets/pdf/curriculam/corrigendum/Corrigendum-1NutritionandDietetics_10-04-2026.pdf";
import Corrigendum_2_05_08_2026 from "../../assets/pdf/curriculam/corrigendum/Corrigendum_2_dt05Aug2026_Nutrition_and_Dietetics.pdf";
import OT_27_05_2026 from "../../assets/pdf/curriculam/corrigendum/OT1_27May2026.pdf";
import Corrigendum_08_06_2026 from "../../assets/pdf/curriculam/corrigendum/Corrigendum_1_MPSW.pdf";
import EMT_06_05_2026 from "../../assets/pdf/curriculam/corrigendum/CORRIGENDUM -1_EMT_06May2026.pdf";
import Corrigendum_1Physician_Associates08Apr2026 from "../../assets/pdf/curriculam/corrigendum/Corrigendum-1Physician-Associates08Apr2026.pdf";

// letter-date pdfs
import file_20_06_2025_Curriculum from "../../assets/pdf/curriculam/letter-date/10-Curriculum-20-06-2025.pdf";
import file_02_02_2026_Medical_Psychiatric_Social_Work from "../../assets/pdf/curriculam/letter-date/Curriculum-02-02-2026-Medical-and-Psychiatric-Social-Work.pdf";
import file_13_01_2026_Curriculum from "../../assets/pdf/curriculam/letter-date/Curriculum-13-01-2026.pdf";
import file_24_03_2026_Medical_Physics from "../../assets/pdf/curriculam/letter-date/Curriculum-24-03-2026-Medical-Physics.pdf";
import file_30_03_2026_NMT from "../../assets/pdf/curriculam/letter-date/Curriculum-30-03-2026-NMT.pdf";
import file_17_10_2025_OT_MLT from "../../assets/pdf/curriculam/letter-date/Curriculum-OT-MLT-17-10-2025.pdf";
import file_03_07_2026_CD_MLT from "../../assets/pdf/curriculam/letter-date/Curriculum-DM-LT-03-07-2026.pdf";
import file_19_10_2026_DT from "../../assets/pdf/curriculam/letter-date/Curriculum Dt.19-10-2026.pdf";

const Curriculum = ({ curriculumDataProp }) => {
  document.title = "Curriculum | Gujarat State Allied and Healthcare Council";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderCorrigendumLinks = (item) => {
    const corrigenda = Array.isArray(item.corrigendumList)
      ? item.corrigendumList.filter(Boolean)
      : [
        item.corrigendum3 && item.corrigendum3Link
          ? { label: item.corrigendum3, link: item.corrigendum3Link }
          : null,
        item.corrigendum2 && item.corrigendum2Link
          ? { label: item.corrigendum2, link: item.corrigendum2Link }
          : null,
        item.corrigendum && item.corrigendumLink
          ? { label: item.corrigendum, link: item.corrigendumLink }
          : null,
      ].filter(Boolean);

    const orderedCorrigenda = [...corrigenda].sort((a, b) => {
      const getNumber = (label) => {
        const match = (label || "").match(/corrigendum[- ]?(\d+)/i);
        return match ? Number(match[1]) : 0;
      };

      return getNumber(b.label) - getNumber(a.label);
    });

    if (!orderedCorrigenda.length) return "-";

    return (
      <div className="d-flex flex-column gap-1">
        {orderedCorrigenda.map((corrigendum, index) => (
          <a
            key={`${corrigendum.label}-${index}`}
            href={corrigendum.link}
            target="_blank"
            rel="noopener noreferrer"
            className="custom-link"
          >
            {corrigendum.label}
          </a>
        ))}
      </div>
    );
  };

  // Array of curriculum data
  const curriculumData = curriculumDataProp || [
    {
      title: "Diploma in Medical Radiology and Imaging Technology",
      link: DMIRT,

      letterDate: "19-10-2026",
      letterLink: file_19_10_2026_DT,
    },
    {
      title: "Diploma in Ophthalmic Assistant(D.OA)",
      link: DOACurriculum,

      letterDate: "19-10-2026",
      letterLink: file_19_10_2026_DT,
    },
    {
      title: "Diploma in Medical laboratory Technology",
      link: DMLTCurriculum,

      letterDate: "03-07-2026",
      letterLink: file_03_07_2026_CD_MLT,
    },
    {
      title: "Nuclear Medicine Technology",
      link: NuclearMedicineTechnology,

      letterDate: "30-03-2026",
      letterLink: file_30_03_2026_NMT,
    },
    {
      title: "Medical Physics",
      link: MedicalPhysics,

      letterDate: "24-03-2026",
      letterLink: file_24_03_2026_Medical_Physics,
    },
    {
      title: "Medical and Psychiatric Social Work",
      link: MedicalPsychiatricSocialWork,

      letterDate: "02-02-2026",
      letterLink: file_02_02_2026_Medical_Psychiatric_Social_Work,

      corrigendum: "Corrigendum-1 dt08.06.2026",
      corrigendumLink: Corrigendum_08_06_2026,
    },
    {
      title: "Respiratory Technology",
      link: RespiratoryTechnology,

      letterDate: "13-01-2026",
      letterLink: file_13_01_2026_Curriculum,

      corrigendum: "Corrigendum-1 dt10.03.2026",
      corrigendumLink: Corrigendum_1,
    },
    {
      title:
        "Emergency Medical Technologist(Paramedic), Burn Care Technologist and Advance care Paramedic",
      link: TaurmaBurn,
      letterDate: "13-01-2026",
      letterLink: file_13_01_2026_Curriculum,
      corrigendum: "Corrigendum-1 dt06.05.2026",
      corrigendumLink: EMT_06_05_2026,
    },
    {
      title: "Occupational Therapy",
      link: OccupationalTherapy,
      letterDate: "17-10-2025",
      letterLink: file_17_10_2025_OT_MLT,
      corrigendum: "Corrigendum-1 dt27.05.2026",
      corrigendumLink: OT_27_05_2026,
    },
    {
      title: "Medical Laboratory Sciences",
      link: MedicalLaboratorySciences,

      letterDate: "17-10-2025",
      letterLink: file_17_10_2025_OT_MLT,

      corrigendum: "Corrigendum-1 dt20.03.2026",
      corrigendumLink: Corrigendum_1MLS20March2026,
    },
    {
      title: "Physiotherapy",
      link: Physiotherapy,

      letterDate: "20-06-2025",
      letterLink: file_20_06_2025_Curriculum,

      corrigendum: "Corrigendum-1 dt27.01.2026",
      corrigendumLink: Corrigendum_1Physiotherapy,
      corrigendum2: "Corrigendum-2 dt02.07.2026",
      corrigendum2Link: Corrigendum_2Physiotherapy,
      corrigendum3: "Corrigendum-3 dt20.07.2026",
      corrigendum3Link: Corrigendum_3Physiotherapy,
    },
    {
      title: "Applied Psychology and Behavioural Health",
      link: AppliedPsychologyAndBehaviouralHealth,

      letterDate: "20-06-2025",
      letterLink: file_20_06_2025_Curriculum,

      corrigendum: "Corrigendum-1 dt01.04.2026",
      corrigendumLink: Corrigendum_1AppliedPsychology01Apr2026,
    },
    {
      title: "Optometry",
      link: Optometry,

      letterDate: "20-06-2025",
      letterLink: file_20_06_2025_Curriculum,

      corrigendum: "Corrigendum-1 dt29.10.2025",
      corrigendumLink: Corrigendum_Optometry,
      corrigendum2: "Corrigendum-2 dt13.05.2026",
      corrigendum2Link: Corrigendum_2Optometry,
    },
    {
      title: "Nutrition and Dietetics",
      link: NutritionAndDietetics,

      letterDate: "20-06-2025",
      letterLink: file_20_06_2025_Curriculum,

      corrigendum: "Corrigendum-1 dt10.04.2026",
      corrigendumLink: Corrigendum_10_04_2026,
      corrigendum2: "Corrigendum-2 dt05.08.2026",
      corrigendum2Link: Corrigendum_2_05_08_2026,
    },
    {
      title: "Dialysis Therapy Technology & Dialysis Therapy",
      link: DialysisTechnologyAndTherapy,

      letterDate: "20-06-2025",
      letterLink: file_20_06_2025_Curriculum,

      corrigendum: "Corrigendum-1 dt13.05.2026",
      corrigendumLink: Corrigendum_13_05_2026,
    },
    {
      title: "Radiotherapy Technology",
      link: RadiotherapyTechnology,

      letterDate: "20-06-2025",
      letterLink: file_20_06_2025_Curriculum,

      corrigendum: "Corrigendum-1 dt27.05.2026",
      corrigendumLink: Corrigendum_27_05_2026,
    },
    {
      title: "Medical Radiology and Imaging Technology",
      link: MedicalRadiologyAndImagingTechnology,

      letterDate: "20-06-2025",
      letterLink: file_20_06_2025_Curriculum,

      corrigendum: "Corrigendum-1 dt06.05.2026",
      corrigendumLink: Corrigendum_06_05_2026,
    },
    {
      title: "Anesthesia and Operation Theatre Technology",
      link: AnesthesiaAndOperationTheatreTechnology,

      letterDate: "20-06-2025",
      letterLink: file_20_06_2025_Curriculum,

      corrigendum: "Corrigendum-1 dt27.04.2026",
      corrigendumLink: Corrigendum_27_04_2026,
    },
    {
      title: "Health Information Management",
      link: HealthInformationManagement,

      letterDate: "20-06-2025",
      letterLink: file_20_06_2025_Curriculum,

      corrigendum: "Corrigendum-1 dt05.02.2026",
      corrigendumLink: Corrigendum_HIM_1dt05Feb2026,
    },
    {
      title: "Physician Associates",
      link: PhysicianAssociates,

      letterDate: "20-06-2025",
      letterLink: file_20_06_2025_Curriculum,

      corrigendum: "Corrigendum-1 dt08.04.2026",
      corrigendumLink: Corrigendum_1Physician_Associates08Apr2026,
    },
  ];

  return (
    <div className="wrappermain">
      {/*Curriculum Banner Section */}
      <div
        className="banner-image wrappermain"
        style={{
          backgroundImage: "url(" + Background_Member2 + ")",
          backgroundSize: "fill",
          backgroundPosition: "right",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          padding: "25px 0",
        }}
      >
        <div className="banner-inner-breadcrumb">
          <div className="container">
            <nav aria-label="breadcrumb">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={"/"}>Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Curriculums
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/*Curriculum Table Section */}
      <div className="container my-5">
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Sr No</th>
                <th>Curriculums</th>
                <th>GSAHC Letter Date</th>
                <th>Corrigendum</th>
              </tr>
            </thead>
            <tbody>
              {curriculumData.map((item, index) => (
                <tr key={index}>
                  <td>{curriculumData.length - index}</td>

                  <td>
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="custom-link"
                    >
                      {item.title}
                    </a>
                  </td>

                  <td>
                    {item.letterLink ? (
                      <a
                        href={item.letterLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="custom-link"
                      >
                        {item.letterDate}
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>

                  <td>{renderCorrigendumLinks(item)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Curriculum;
